import { autenticazione, database } from '../firebase/config';
import { signInWithEmailAndPassword, createUserWithEmailAndPassword, signOut } from 'firebase/auth';
import { doc, setDoc, getDoc } from 'firebase/firestore';

export const authService = {
  // Login utente
  async login(email, password) {
    try {
      const userCredential = await signInWithEmailAndPassword(autenticazione, email, password);
      return userCredential.user;
    } catch (error) {
      throw new Error(error.message);
    }
  },

  // Registrazione utente
  async register(email, password, displayName) {
    try {
      const userCredential = await createUserWithEmailAndPassword(autenticazione, email, password);
      const user = userCredential.user;
      
      // Salva informazioni aggiuntive nel database
      await setDoc(doc(database, 'users', user.uid), {
        email: user.email,
        displayName: displayName,
        createdAt: new Date(),
        hasVoted: false,
      });
      
      return user;
    } catch (error) {
      throw new Error(error.message);
    }
  },

  // Logout utente
  async logout() {
    try {
      await signOut(autenticazione);
    } catch (error) {
      throw new Error(error.message);
    }
  },

  // Ottieni dati utente dal database
  async getUserData(uid) {
    try {
      const userDoc = await getDoc(doc(database, 'users', uid));
      if (userDoc.exists()) {
        return userDoc.data();
      }
      return null;
    } catch (error) {
      throw new Error(error.message);
    }
  },

  // Aggiorna profilo utente
  async updateUserProfile(uid, profileData) {
    try {
      const userRef = doc(database, 'users', uid);
      await setDoc(userRef, profileData, { merge: true });
      return true;
    } catch (error) {
      throw new Error(error.message);
    }
  },
};